jQuery_T4NT(document).ready(function($) {

	/**
	 *  Variant selection changed
	 *  data-variant-toggle="{{variant.id}}"
	 */
	$( document ).on( "variant:changed", function( evt ) {
		// console.log( evt.currentVariant );
		// $('[data-variant-toggle]').hide(0);
		// $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	});
	let pathname = window.location.pathname;
	let search = window.location.search;
	if(search.includes("filtre=open"))
	{
		setTimeout(function(){
			$(".t4s-btn-filter").trigger("click");
		},500);
	}
	document.getElementById('shopify-section-acc_heading').addEventListener('click', function() {
		location.href = '/account'
	}, false);
});
